export const contactRelinkingValidationMessageTranslations = {
  criticalRelinkingMessage: {
    header: 'cng-contact_relinking_modal-critical_relinking_header',
    useProfilingTicket: 'cng-contact_relinking_modal-critical_relinking_use_profiling_ticket',
    cancel: 'cng-contact_relinking_modal-critical_relinking-buttons_cancel',
  },
}
